module.exports = __webpack_public_path__ + "assets/img/button-submit.ab8fd062.png";